import { ErrorService } from 'src/services';
import { createReducer } from 'typesafe-actions';
import {
  addJobAsync,
  deleteJobAsync,
  getJobsAsync,
  setJobModalType,
  setJobs,
  setRefreshTable,
  setSelectedJob,
  updateJobAsync,
} from './actions';
import { JobInfo, JobModalType } from './types';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */

export const INITIAL_JOB: JobInfo = {
  code: '',
  description: '',
  status: '',
};

export type IJobsState = Readonly<{
  jobs: Array<JobInfo>;
  totalJobs: number;
  isLoading: boolean;
  openModalType: JobModalType;
  selectedJob: JobInfo;
  isRefresh: boolean;
}>;

const initialState: IJobsState = {
  jobs: [],
  totalJobs: 0,
  isLoading: false,
  openModalType: null,
  selectedJob: INITIAL_JOB,
  isRefresh: false,
};

/* ------------- Selectors ------------- */

export default createReducer(initialState)
  /* ------------- jobAsync ------------- */
  .handleAction(getJobsAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(getJobsAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    // isRefresh: false,
    jobs: action.payload.jobCodes as JobInfo[],
    totalJobs: action.payload.total,
    error: null,
  }))
  .handleAction(getJobsAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- jobUpdateAsync ------------- */
  .handleAction(updateJobAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(updateJobAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    openModalType: false,
    selectedJob: INITIAL_JOB,
    isRefresh: true,
    error: null,
  }))
  .handleAction(updateJobAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- jobAddAsync ------------- */

  .handleAction(addJobAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(addJobAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    openModalType: false,
    selectedJob: INITIAL_JOB,
    isRefresh: true,
    error: null,
  }))
  .handleAction(addJobAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- jobDeleteAsync ------------- */
  .handleAction(deleteJobAsync.request, state => ({
    ...state,
    isLoading: true,
  }))
  .handleAction(deleteJobAsync.success, (state, action) => ({
    ...state,
    isLoading: false,
    isRefresh: true,
    openModalType: false,
    selectedJob: INITIAL_JOB,
    error: null,
  }))
  .handleAction(deleteJobAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: ErrorService.asyncFailure(action.payload.data),
  }))

  /* ------------- setJobs ------------- */
  .handleAction(setJobs, (state, action) => ({
    ...state,
    jobs: action.payload,
  }))
  .handleAction(setJobModalType, (state, action) => ({
    ...state,
    openModalType: action.payload,
  }))
  .handleAction(setSelectedJob, (state, action) => ({
    ...state,
    selectedJob: action.payload,
  }))
  .handleAction(setRefreshTable, (state, action) => ({
    ...state,
    isRefresh: action.payload,
  }));
